export default {
  sm: `
  클라우드를 이용하면 데이터를 비용, 기술적
  인 면에서 효율적으로 활용할 수 있습니다.
  NAVER CLOUD PLATFORM은 무한대의
  가능성을 제공합니다.
  `,
  md: `
  클라우드를 이용하면 데이터를 비용, 기술적인 면에서 효율적으로 
  활용할 수 있습니다. NAVER CLOUD PLATFORM은 무한대의 가능성을 제공합니다.        
  `,
  lg: `
  클라우드를 이용하면 데이터를 비용면에서나 기술적인 면에서 효율적으로 축적하고 
  활용할 수 있습니다. NAVER CLOUD PLATFORM은 무한대의 가능성을 제공합니다.      
  `,
};
